import useProviderInsuranceUpdate from 'apollo/mutations/Providers/DOCTOR_INSURANCE_UPDATE'
import useCreateRoadmapEntity from 'apollo/mutations/CarePlan/CREATE_CAREPLAN_ENTITY'
import useUpdateRoadmapEntity from 'apollo/mutations/CarePlan/UPDATE_CAREPLAN_ENTITY'
import useDeleteRoadmapEntity from 'apollo/mutations/CarePlan/DESTORY_CAREPLAN_ENTITY'
import useFacilityInsuranceUpdate from 'apollo/mutations/Facilities/FACILITY_INSURANCE_UPDATE'

const useEntities = (
  carePlan,
  setVisible,
  selectedEntity,
  setLoading,
  employee_id
) => {
  const { isFacility, suggested_doctors, suggested_facilities } = carePlan
  const entityType = isFacility ? 'Facility' : 'Provider'

  const { onProviderInsuranceUpdate, loading: providerInsuranceLoading } =
    useProviderInsuranceUpdate()
  const { onFacilityInsuranceUpdate, loading: facilityInsuranceLoading } =
    useFacilityInsuranceUpdate()
  const { onCreateRoadmapEntity, loading: createRoadmapLoading } =
    useCreateRoadmapEntity()
  const {
    onUpdateRoadmapEntity,
    loading: updateRoadmapLoading,
    carePlanLoading
  } = useUpdateRoadmapEntity()
  const { onDeleteRoadmapEntity, loading: deleteRoadmapLoading } =
    useDeleteRoadmapEntity()

  setLoading(
    createRoadmapLoading ||
      updateRoadmapLoading ||
      deleteRoadmapLoading ||
      providerInsuranceLoading ||
      facilityInsuranceLoading
  )

  const entitiesData = isFacility ? suggested_facilities : suggested_doctors
  const entities = entitiesData.map(
    ({ profile, cost, navigator_notes, insurance_tier, contact_uuid }) => ({
      ...profile,
      // TODO: The data should be unified on backend to avoid such mapping.
      // The tech debt story is created
      cost: cost?.total,
      cost_copay: cost?.copay,
      cost_coinsurance: cost?.insurance_copay,
      cost_deductible: cost?.deductible,
      cost_not_covered: cost?.user_pays,
      insurance_tier_id: insurance_tier?.id,
      preferred_insurance_benefit_tier_name: insurance_tier?.name,
      insurance_plan: insurance_tier?.insurance_plan?.id,
      insurance_plan_name: insurance_tier?.insurance_plan?.display_name,
      carrier_display_name:
        insurance_tier?.insurance_plan?.carrier_display_name,
      navigator_notes,
      contact_uuid
    })
  )

  const entitiesIDs = entities.map(item => item.id)

  const onRemoveEntity = async ({ id }) => {
    const entity = entities.find(item => item.id === id)
    const { isErrorFree } = await onDeleteRoadmapEntity({
      roadmap_id: carePlan.id,
      entity_id: entity.id,
      entity_type: entityType
    })

    return { isErrorFree }
  }

  const onSaveEntity = async values => {
    const { npi_id: npi, id, uuid } = selectedEntity
    const entity = entities.find(item => item.id === id)

    const {
      insurance_tier_id: preferredInsurance,
      location_uuid,
      insurance_plan
    } = values

    let preferredUuid, preferredId

    if (preferredInsurance) {
      ;[, , preferredUuid, preferredId] = preferredInsurance.split(',')

      preferredUuid = preferredUuid === 'null' ? null : preferredUuid
    }

    const baseAttributes = {
      cost: values.cost,
      cost_coinsurance: values.cost_coinsurance,
      cost_copay: values.cost_copay,
      cost_deductible: values.cost_deductible,
      cost_not_covered: values.cost_not_covered,
      navigator_notes: values.navigator_notes,
      ...(preferredInsurance &&
        preferredInsurance !== selectedEntity.insurance_tier_name && {
          insurance_tier_id: preferredId
        })
    }

    const updatedAttributes = {
      ...baseAttributes,
      ...(!isFacility &&
        selectedEntity.contact_uuid !== location_uuid && {
          contact_uuid: location_uuid
        })
    }

    const variables = {
      roadmap_id: carePlan.id,
      entity_id: id || selectedEntity.id,
      entity_type: entityType,
      attributes: updatedAttributes
    }

    const insuranceChanged =
      insurance_plan &&
      preferredUuid &&
      preferredUuid !== selectedEntity.insurance_tier_id

    if (insuranceChanged) {
      const insuranceUpdatePayload = { add_uids: [preferredUuid] }
      if (isFacility) {
        await onFacilityInsuranceUpdate({
          location_uuid: uuid,
          employee_id,
          ...insuranceUpdatePayload
        })
      } else if (location_uuid) {
        await onProviderInsuranceUpdate({
          npi,
          location_uuid,
          employee_id,
          ...insuranceUpdatePayload
        })
      }
    }

    const { isErrorFree } = entity
      ? await onUpdateRoadmapEntity(variables)
      : await onCreateRoadmapEntity(variables)

    if (isErrorFree) setVisible(false)
  }

  return {
    entities,
    entitiesIDs,
    loading:
      createRoadmapLoading ||
      updateRoadmapLoading ||
      deleteRoadmapLoading ||
      providerInsuranceLoading ||
      facilityInsuranceLoading,

    carePlanLoading,

    onSaveEntity,
    onRemoveEntity
  }
}

export default useEntities
